/**
 * CartBadge Component
 * Shopping cart icon with item count badge for header navigation
 */

import React from 'react';
import { IconButton, Badge, Tooltip, useTheme } from '@mui/material';
import { ShoppingCart as CartIcon } from '@mui/icons-material';
import { useCartStore } from '../../store/cart';

interface CartBadgeProps {
  onClick: () => void;
}

const CartBadge: React.FC<CartBadgeProps> = ({ onClick }) => {
  const theme = useTheme();
  const itemCount = useCartStore(state => state.getItemCount());

  return (
    <Tooltip title={itemCount > 0 ? `${itemCount} item(s) in cart` : 'Cart is empty'}>
      <IconButton
        onClick={onClick}
        color="inherit"
        sx={{
          '&:hover': {
            bgcolor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        <Badge
          badgeContent={itemCount}
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.7rem',
              height: 18,
              minWidth: 18,
            },
          }}
        >
          <CartIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default CartBadge;
